"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { useUser } from "./user-context";

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { preferences } = useUser();
  const defaultTheme = preferences?.theme || "system";

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme={defaultTheme}
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
